import request from '@/utils/request'

export function getRequestedWHParts(branchId, size, page, find) {
  return request({
    url: `/tkitchen/requestedwhparts/${branchId}`,
    method: 'get',
    params: {
      size: size,
      page: page,
      find: find
    }
  })
}

export function getRequestedWHPartById(branchId, id) {
  return request({
    url: `/tkitchen/requestedwhparts/id/${branchId}/${id}`,
    method: 'get'
  })
}

export function findRequestedWHParts(branchId, find) {
  return request({
    url: `/tkitchen/requestedwhparts/${branchId}`,
    method: 'get',
    params: {
      find: find
    }
  })
}

export function createRequestedWHParts(branchId, data) {
  return request({
    url: `/tkitchen/requestedwhparts/create/${branchId}`,
    method: 'post',
    data
  })
}

export function duplicateRequestedWHParts(branchId, id) {
  return request({
    url: `/tkitchen/requestedwhparts/duplicate/${branchId}/${id}`,
    method: 'post'
  })
}

export function updateRequestedWHParts(branchId, id, data) {
  return request({
    url: `/tkitchen/requestedwhparts/id/${branchId}/${id}`,
    method: 'put',
    data
  })
}

export function removeRequestedWHParts(branchId, id) {
  return request({
    url: `/tkitchen/requestedwhparts/id/${branchId}/${id}`,
    method: 'delete'
  })
}

export function getRequestedWHPartNotifications(branchId) {
  return request({
    url: `/tkitchen/requestedwhparts/notifications/${branchId}`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/tkitchenRequestedWHParts.js